import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=3f8d63fd"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"
import style0 from "./profile.vue?vue&type=style&index=0&id=3f8d63fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports